import { render } from "./ReservationChatPanel.vue?vue&type=template&id=74458e5d&scoped=true"
import script from "./ReservationChatPanel.vue?vue&type=script&lang=js"
export * from "./ReservationChatPanel.vue?vue&type=script&lang=js"

import "./ReservationChatPanel.vue?vue&type=style&index=0&id=74458e5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74458e5d"]])

export default __exports__